import { Mqtt_Topics_userChanges } from "../RAWMap.Models/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Msg } from "./AuthTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_userChanges(uid)), (Item) => (new Msg(17, [Item]))];
}

